module.exports = __webpack_public_path__ + "img/impostor-bg-1.3c6722c5.webp";